module.exports = __webpack_public_path__ + "da0a24f0f88ffbe3fb46af6139d56c9a.pdf";